import { render, staticRenderFns } from "./clickButton.vue?vue&type=template&id=10c20e5c&scoped=true"
import script from "./clickButton.vue?vue&type=script&lang=js"
export * from "./clickButton.vue?vue&type=script&lang=js"
import style0 from "./clickButton.vue?vue&type=style&index=0&id=10c20e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c20e5c",
  null
  
)

export default component.exports